module.exports = __webpack_public_path__ + "static/img/logo_pulsar_white.f6aaf32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_pulsar_white.png
// module id = nmU8
// module chunks = 1